import { ref } from "vue";
import { defineStore } from "pinia";

import type { DsLiveNotificationToast } from "./DsLiveNotifier.types";

export const useDsLiveNotifierStore = defineStore("ds-live-notifier", () => {
  const toasts = ref<DsLiveNotificationToast[]>([]);
  const unread = ref<number>(0);

  const $reset = (): void => {
    toasts.value = [];
    unread.value = 0;
  };

  const addToast = (toast: DsLiveNotificationToast): void => {
    toasts.value.push(toast);
  };

  const deleteToast = (id: number): void => {
    const index = toasts.value.findIndex((toast) => {
      return toast.id === id;
    });
    //If index found, delete the notification
    if (index !== -1) {
      toasts.value.splice(index, 1);
    }
  };

  const setUnread = (totalUnread: number): void => {
    unread.value = totalUnread;
  };

  return {
    $reset,
    toasts,
    unread,
    addToast,
    deleteToast,
    setUnread,
  };
});
